// quiz home section 
// quiz-results-btn(class-nameof btn )

$("body").on("click",".tgleprdct",function(e){
//   $(".toggle-cleanse-products").show();
  e.preventDefault();
});

// nutrient section flipping

$("body").on("click",".nut-content",function(){
  $(this).children().toggleClass("flipped");
});


$("body").on("click",".cleanse-select-btn .cta",function(){
//   $(".toggle-cleanse-products").show();
});


if ($(window).width() < 768) {
  $("body").on("click",".coldpressbtn",function(){
    $(this).prev().children().toggleClass("flip");
//     $(this).children("span:contains(more)").css("background-color", "yellow");
//     $(this).children('span').text("Read Less");
  });
  $(".coldbtna").click(function () {
    $(this).text(function(i, text){
      return text === "read more" ? "read less" : "read more";
    })
  });
  

}
else {

  $(".dcoldpress").mouseenter(function(){
    $(this).find(".coldpress-image").children().toggleClass("flip");
    $(this).find(".coldpressbtn").children('span').text("Read Less");
  });
  $(".dcoldpress").mouseleave(function(){
    $(this).find(".coldpress-image").children().toggleClass("flip");
    $(this).find(".coldpressbtn").children('span').text("Read More");
    
  });
  


}



// 3-up card section flipping
//   if ($(window).width() < 768) {
//     $("body").on("click",".coldpressbtn",function(){
//       $(this).prev().children().toggleClass("flip");
//     });
//   }
//   else {
//     $(".coldpressbtn").mouseenter(function(){
//       $(this).prev().children().toggleClass("flip");
//     });
//     $(".coldpressbtn").mouseleave(function(){
//       $(this).prev().children().toggleClass("flip");
//     });

//   }
// });

// blog page filters css 
  $('.select-main-dropdown').click(function(){
    $('.collection-dropdown').toggleClass("dropdown-show");
    $(this).toggleClass("expanded-btn");
  });


  $("body").on("change",".filterval",function(){
    $(".clearfltrbtn").show();
    var $this = $(this);
    $(".clearfltrbtn").addClass('loading2');
    var selectedfiltervalue = $(this).attr("value");
    var url = '/blogs/news/tagged/' + selectedfiltervalue ;
    $.ajax({
      url: url ,

      type: 'GET',
      success: function(responseHTML){        
        window.history.pushState("data","Title",url);
        $('.all-blogarticles').html($(responseHTML).find('.all-blogarticles').html());
        $('.pagination-wrapper').empty();
        $('.pagination-wrapper').append($(responseHTML).find('.pagination-wrapper').html());
        $('.collection-dropdown').toggleClass("dropdown-show");
        $(".clearfltrbtn").removeClass('loading2');
      }
    });
  });

  $("body").on("click",".clearfltrbtn",function(){
    var $this = $(this);
    $(this).addClass('loading2');
    var surl = '/blogs/news';
    $.ajax({
      url: surl ,
      type: 'GET',
      success: function(responseHTML){        
        window.history.pushState("data","Title",surl);
        $('.all-blogarticles').html($(responseHTML).find('.all-blogarticles').html());
        $('.pagination-wrapper').empty();
        $('.pagination-wrapper').append($(responseHTML).find('.pagination-wrapper').html());
        $this.removeClass('loading2');
        $('.collection-dropdown').toggleClass("dropdown-show");
        $this.removeClass('loading2');
        $this.hide();
        $(".filterval").prop("checked",false);
        
      }
    });
  });
